module.exports = __webpack_public_path__ + "img/template-1.1864ed2a.jpg";